import React from "react";
import ReactDOM from "react-dom";
import AppLayout from "./App/Layout/index";
import Home from "./App/Home/index";
import { BrowserRouter as Router } from 'react-router-dom';
import CustomRoute from './App/Helpers/CustomRoute';
import Emitidos from "./App/Emitidos/index";
import Recibidos from "./App/Recibidos/index";
import EditarCorreo from './App/Administracion/Correo/EditarCorreo';
import Folios from './App/Administracion/Folios/index';
import Certificados from './App/Administracion/Certificados/index';
import ApiKeys from './App/Administracion/ApiKeys/index';
import Reglas from './App/Administracion/Reglas/index';
import MisClientes from './App/Administracion/MisClientes/index';
import Plantillas from './App/Administracion/Plantillas/index';
import Usuarios from './App/Administracion/Usuarios/index';
import EditarPlantillas from './App/Administracion/Plantillas/editar';
import Libro from './App/Libros/index';
import Verifica from './App/Verifica/index';
import Tareas from './App/Tareas/index';
//import registerServiceWorker from './registerServiceWorker';
import { AuthProvider } from "react-oidc-context";
import oidcConfiguration from './oidcConfig';
import axios from 'axios';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { LayoutProvider } from "App/Layout/store";
import { nest } from 'recompose';
import { FoliosProvider } from "App/Administracion/Folios/store";
import { RecibidosProvider } from 'App/Recibidos/store';
import { CertificadosProvider } from 'App/Administracion/Certificados/store';
import { AdministracionProvider } from 'App/Administracion/store';
import { CesionProvider } from 'App/Cesion/store';
import { TareasProvider } from 'App/Tareas/store';
import moment from 'moment';
import AxiosErrorHandler from './AxiosErrorHandler'

require('moment/locale/es');

pdfMake.vfs = pdfFonts.pdfMake.vfs;
moment.locale('es');


axios.defaults.headers.post['Content-Type'] = 'application/json';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const Stores = nest(
  LayoutProvider,
  FoliosProvider,
  RecibidosProvider,
  CertificadosProvider,
  AdministracionProvider,
  CesionProvider,
  TareasProvider
);

ReactDOM.render(
  <Router basename={baseUrl}>
    <Stores key={1}>
      <AuthProvider key={0} {...oidcConfiguration}>
        <AppLayout key={2}>
          <CustomRoute exact path="/" component={Home} />
          <CustomRoute exact path="/Documento/:emisor/:tipo/:folio" component={Home} />
          <CustomRoute exact path="/Recibidos" component={Recibidos} />
          <CustomRoute exact path="/Emitidos" component={Emitidos} />
          <CustomRoute exact path="/Administracion/Correo" component={EditarCorreo} />
          <CustomRoute exact path="/Administracion/Folios" component={Folios} />
          <CustomRoute exact path="/Administracion/Certificados" component={Certificados} />
          <CustomRoute exact path="/Administracion/ApiKeys" component={ApiKeys} />
          <CustomRoute exact path="/Administracion/Reglas" component={Reglas} />
          <CustomRoute exact path="/Administracion/MisClientes" component={MisClientes} />
          <CustomRoute exact path="/Administracion/Usuarios" component={Usuarios} />
          <CustomRoute exact path="/Administracion/Plantillas" component={Plantillas} />
          <CustomRoute exact path="/Administracion/Plantillas/:id" component={EditarPlantillas} />
          <CustomRoute exact path="/Libros" component={Libro} />
          <CustomRoute exact path="/verifica" component={Verifica} />
          <CustomRoute exact path="/verifca" component={Verifica} />
          <CustomRoute exact path="/Tareas" component={Tareas} />
        </AppLayout>
        <AxiosErrorHandler />
      </AuthProvider>
    </Stores>
  </Router>,
  rootElement);

//registerServiceWorker();